<template>
    <div class="mx-auto" style="max-width: 1400px">
      <h2 class=" mt-10 px-4 text-2xl font-bold tracking-wider text-primary mb-5">
          <span class="category-title">{{T(category)}}</span>
      </h2>
<!--      <div class="px-4 mb-8">-->
<!--      <hr class="border-b border-gray-900">-->
<!--      </div>-->

      <div class="flex flex-wrap">
        <router-link class="w-full md:w-1/2 cursor-pointer" tag="div" :to="'/project/'+project.slug" v-for="(project,index) in $store.getters.getProjectsByCategory(category)">

            <img :src="project.cover_thumb"
                 :alt="project.title[locale()]"
                 class="max-w-full my-4 px-4"
            >

          <div class="my-4 px-4">
            <h2 class="text-2xl font-bold">{{ project.title[locale()] }}</h2>
            <div v-html="shorten(project.excerpt[locale()],240)"></div>
          </div>
        </router-link>
      </div>
      <div class="px-4 mt-8">
        <hr class="border-b border-gray-900">
      </div>
    </div>
</template>
<script>

  export default {
    name: 'TwoColumnsProjects',
    props:{
      category:{
        type:String,
        required:true
      }
    },
    mounted(){
    }
  }
</script>

<style lang="scss" scoped>
  .category-title{
    @apply items-center inline-flex;
    &:before{
      content: '';
      @apply border border-gray-600;
      width:30px;
      margin-right: 10px;
    }
    //&:after{
    //  content: '';
    //  border: 1px solid #86868b;
    //  width:10px;
    //  margin-left: 5px;
    //}
  }
</style>
